"use strict";

{
    // ハンバーガーメニューの動き
    const hamburgerBtn = document.querySelector('.hamburger-btn');
    const hamburgerNav = document.querySelector('.header-menu-container nav');
    const hamburgerCloseBtn = document.querySelector('.hamburger-close-btn');

    hamburgerBtn.addEventListener('click', () => {
        hamburgerNav.classList.add('active');
    })

    hamburgerCloseBtn.addEventListener('click', () => {
        hamburgerNav.classList.remove('active');
    })

    // コラボレーションのスライダー
    const collaboSwiper = new Swiper(".collabo-swiper", {
        loop: true,
        autoplay: true,
        speed: 1000,
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-pagination.collabo",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // スライドの表示枚数：769px以上の場合
            769: {
                slidesPerView: 2.5,
                spaceBetween: 70,
            },
        },
    });

    window.addEventListener("load", function () {
        scrollPos();
    });
    
    window.addEventListener("scroll", function () {
        scrollPos();
    });
    
    // フェードイン要素にクラスをつける処理
    function scrollPos() {
        var scrollElements = document.querySelectorAll(".scroll-fade");
        var windowHeight = window.innerHeight;
    
        scrollElements.forEach(function (element) {
            var imgPos = element.getBoundingClientRect().top + window.scrollY;
    
            if (window.scrollY > imgPos - windowHeight + windowHeight / 5) {
                element.classList.add("fade_on");
            }
        });
    }

}

